module.exports = __webpack_public_path__ + "img/pause.d21c6540.svg";